import { gozokiApiWithAuth } from '../gozokiApi'

export interface ContactResponse {
  id: string
  name: string
  email: string
  phone: string
  entrepreneurshipStatus?: 'NONE' | 'ENTREPRENEUR'
  partner?: boolean
}

// Fetch all contacts
export const fetchContacts = async () => {
  const response = await gozokiApiWithAuth.get<ContactResponse[]>('/contacts')
  return response.data
}
